import React from 'react';
import { ANIMATION_IN, ANIMATION_OUT } from '../../../../../config/constants';
import { Row, Col } from 'reactstrap';
import { Animated } from 'react-animated-css';

export default class ExamFinish extends React.Component<any, any> {

  constructor(props) {
    super(props);
  
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <>
        <Animated animationIn={ANIMATION_IN} animationOut={ANIMATION_OUT} isVisible>
          <div className="text-center">
            <div className="grid-icon size-200 icon-finish mb-4">
            </div>
            <div>
              <span className="text-red"><strong>Your score: {this.props.score}/{this.props.total}</strong></span>
            </div>
          </div>
        </Animated>
      </>
    );
  }
}